/**
 * Button Loading Manager
 * Gerencia o estado de loading de botões de adicionar ao carrinho
 * de forma reutilizável para diferentes componentes
 */
(function() {
  'use strict';

  /**
   * Reseta o estado do botão
   */
  function resetButtonState(button) {
    if (!button) return;
    button.setAttribute('aria-busy', 'false');
    button.disabled = false;
  }

  /**
   * Calcula o min-width do botão baseado no tamanho atual
   * para manter o tamanho durante o loading
   */
  function calculateMinWidth(button) {
    if (!button) return null;
    
    // Força reflow para garantir medidas precisas
    void button.offsetWidth;
    
    // Pega o tamanho atual do botão antes de esconder conteúdo
    const rect = button.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(button);
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const borderLeft = parseFloat(computedStyle.borderLeftWidth) || 0;
    const borderRight = parseFloat(computedStyle.borderRightWidth) || 0;
    
    // Calcula largura total incluindo padding e border
    const totalWidth = rect.width;
    
    // Retorna o tamanho mínimo necessário (largura atual ou padding * 2 + espaço para spinner)
    // Usa a largura atual como base para garantir que não diminua
    return Math.max(totalWidth, (paddingLeft + paddingRight + borderLeft + borderRight) + 50);
  }

  /**
   * Inicia o estado de loading no botão
   */
  function startLoading(button, duration = 2000) {
    if (!button) return;
    
    // Limpa timeout anterior se existir
    if (button._loadingTimeout) {
      clearTimeout(button._loadingTimeout);
    }

    // Calcula e define min-width ANTES de ativar aria-busy
    // Isso garante que pegamos o tamanho real antes do CSS esconder conteúdo
    const minWidth = calculateMinWidth(button);
    if (minWidth && minWidth > 0) {
      button.style.minWidth = minWidth + 'px';
      // Força reflow para aplicar o min-width
      void button.offsetWidth;
    }

    // Ativa estado de loading (isso vai esconder o conteúdo via CSS)
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    // Define timeout para resetar
    button._loadingTimeout = setTimeout(function() {
      resetButtonState(button);
      // Remove min-width após um pequeno delay para permitir transição suave
      setTimeout(function() {
        if (button.style.minWidth) {
          button.style.minWidth = '';
        }
      }, 50);
    }, duration);
  }

  /**
   * Para o loading imediatamente
   */
  function stopLoading(button) {
    if (!button) return;
    
    if (button._loadingTimeout) {
      clearTimeout(button._loadingTimeout);
      button._loadingTimeout = null;
    }
    
    resetButtonState(button);
    if (button.style.minWidth) {
      button.style.minWidth = '';
    }
  }

  /**
   * Inicializa o loading para botões dentro de um seletor específico
   * @param {string} selector - Seletor CSS para encontrar os botões
   * @param {number} duration - Duração do loading em ms (padrão: 2000ms)
   */
  function initButtonLoading(selector, duration = 2000) {
    const buttons = document.querySelectorAll(selector);
    
    if (buttons.length === 0) return;

    buttons.forEach(button => {
      // Evita múltiplas inicializações
      if (button._loadingInitialized) return;
      button._loadingInitialized = true;

      // Handler para submit de formulário
      const formComponent = button.closest('product-form-component');
      if (formComponent) {
        formComponent.addEventListener('submit', function(e) {
          // Pequeno delay para garantir que o botão está renderizado
          requestAnimationFrame(function() {
            startLoading(button, duration);
          });
        });
      }

      // Handler para click em quick-add
      const quickAddComponent = button.closest('quick-add-component');
      if (quickAddComponent) {
        button.addEventListener('click', function(e) {
          // Só inicia loading se o botão não estiver já em loading
          if (button.getAttribute('aria-busy') !== 'true') {
            requestAnimationFrame(function() {
              startLoading(button, duration);
            });
          }
        });
      }

      // Handler para submit direto do botão
      if (button.type === 'submit') {
        const form = button.closest('form');
        if (form) {
          form.addEventListener('submit', function(e) {
            requestAnimationFrame(function() {
              startLoading(button, duration);
            });
          });
        }
      }

      // Handlers para eventos de carrinho
      function handleCartUpdate() {
        stopLoading(button);
      }

      document.addEventListener('cart:update', handleCartUpdate);
      document.addEventListener('cart:error', handleCartUpdate);
    });
  }

  // Exporta para uso global
  window.ButtonLoading = {
    init: initButtonLoading,
    start: startLoading,
    stop: stopLoading,
    reset: resetButtonState
  };

  function initAllButtonLoading() {
    initButtonLoading('.cart-complementary-product__add-to-cart', 2000);
    initButtonLoading('.product-sticky-cart__add-to-cart', 2000);
    initButtonLoading('button.quick-add__button--cta-bar', 2000);
  }

  // Auto-inicializa quando DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAllButtonLoading, 100);
    });
  } else {
    setTimeout(initAllButtonLoading, 100);
  }

  // Re-inicializa quando novas seções são carregadas no editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initAllButtonLoading, 200);
    });
  }
})();
